import React from "react";
import styles from "./Table.module.css";

export default function TableSkeleton({ columns = [], rows = 6 }) {
  return Array.from({ length: rows }).map((_, rowIndex) => (
    <tr key={rowIndex} className={styles.skeletonRow}>
      {columns.map((column) => (
        <td key={column.key}>
          <span className={`${styles.skeletonLine} ${column.skeletonClassName || ""}`.trim()} />
        </td>
      ))}
    </tr>
  ));
}
